import React, { useMemo } from 'react';
import { Box } from 'rebass';
import classNames from 'classnames';

import moment from 'utils/moment';
import { countryCodeToFlag, countryCodeToName } from 'utils/countryDisplay';
import { DATE_STYLES, getMomentFormat } from 'utils/dateFormats';

/**
 * Display metadata about the screener and hide it when not printing
 *
 * @param {boolean} isHiddenPrint Indicates if the metadata should be visible when printing
 * @param {string} ip IP address of the respondent
 * @param {Date | string | number} answeredAt Date and time the screener was answered
 * @param {string?} timezone Timezone of the current user
 * @param {string?} countryCode Two-letter country code from ipinfo
 * @param {React.CSSProperties?} style
 * @param {string?} className
 */
export function ScreenerAnswersMetadata({ isHiddenPrint, ip, answeredAt, timezone, countryCode, style, className }) {
    const formattedAnsweredAt = useMemo(() => {
        let value = moment(answeredAt);

        if (timezone) {
            value = value.tz(timezone);
        }

        return value.format(getMomentFormat(DATE_STYLES.HUMAN_DATE_TIME_SECONDS_TZ));
    }, [answeredAt, timezone]);

    return (
        <Box className={className} style={style}>
            {!isHiddenPrint && <Box as="hr" my="8px" />}
            <Box className={classNames('fs-body-14 color-text-secondary', isHiddenPrint && 'hidden-print')} as="p">
                IP Address: {ip}
            </Box>
            <Box className={classNames('fs-body-14 color-text-secondary', isHiddenPrint && 'hidden-print')} as="p">
                Country:{' '}
                <span role="img" aria-label={countryCodeToName(countryCode)}>
                    {countryCodeToFlag(countryCode)}
                </span>{' '}
                {countryCodeToName(countryCode)}
            </Box>
            <Box className={classNames('fs-body-14 color-text-secondary', isHiddenPrint && 'hidden-print')} as="p">
                Answered at: {formattedAnsweredAt}
            </Box>
        </Box>
    );
}

export default ScreenerAnswersMetadata;
